/**
 * Shared matter search matching for header search and Demands list filtering.
 * Fields: debtor, amount, attorney partner, email, company, street, city,
 * state, postal code, demand ID, invoice ID, account number.
 */

function normalizeText(value) {
  return String(value || '')
    .trim()
    .toLowerCase();
}

/** Strip currency formatting so "2,500", "$2500.50", and "2500" all match. */
export function normalizeAmountQuery(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[$,\s]/g, '');
}

function amountSearchValues(matter) {
  const amount = Number(matter.Amount_Owed || 0);
  const raw = String(matter.Amount_Owed ?? '');
  const formatted = amount.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return [raw, formatted, amount.toFixed(2), String(amount)].map(normalizeAmountQuery);
}

function matterSearchHaystack(matter) {
  return [
    matter.Debtor_Name,
    matter.Debtor_Company,
    matter.Attorney_Name,
    matter.Debtor_Email,
    matter.Debtor_Street,
    matter.Debtor_City,
    matter.Debtor_State,
    matter.Debtor_Postal_Code,
    matter.Demand_ID,
    matter.External_Invoice_ID,
    matter.External_Account_Number,
    matter.Invoice_ID,
  ]
    .map(normalizeText)
    .filter(Boolean);
}

export function matchesMatterQuery(matter, query) {
  const q = normalizeText(query);
  if (!q) return false;

  if (matterSearchHaystack(matter).some((field) => field.includes(q))) {
    return true;
  }

  const amountQ = normalizeAmountQuery(query);
  if (amountQ && amountSearchValues(matter).some((value) => value.includes(amountQ))) {
    return true;
  }

  return false;
}

export function filterMattersByQuery(matters, query) {
  const q = String(query || '').trim();
  if (!q) return matters || [];
  return (matters || []).filter((matter) => matchesMatterQuery(matter, q));
}

export const MATTER_SEARCH_HINT =
  'Search by debtor, amount, attorney partner, email, company, street, city, state, postal code, invoice ID, or account number.';
